import { Create, Loading, SimpleForm, useGetList, type RaRecord } from "react-admin";
import type { CreateProps } from "react-admin";

import RelayAccessRequestFormFields, {
  transformRelayAccessRequestCreate,
} from "./RelayAccessRequestFormFields";

type GatedRelayEvent = RaRecord & {
  name?: string;
  requiresAccessGrant?: boolean;
};

const RelayAccessRequestCreateForm = () => {
  const { data = [], isPending } = useGetList<GatedRelayEvent>("relay-events", {
    pagination: { page: 1, perPage: 100 },
    filter: { requiresAccessGrant: true },
  });

  const defaultRelayEventId = [...data]
    .filter((event) => event.requiresAccessGrant)
    .sort((a, b) => String(b.name ?? "").localeCompare(String(a.name ?? "")))[0]?.id as
    | string
    | undefined;

  if (isPending) {
    return <Loading />;
  }

  return (
    <SimpleForm
      warnWhenUnsavedChanges
      sx={{ maxWidth: 640, width: "100%" }}
      defaultValues={{ relayEventId: defaultRelayEventId, audioOnly: false }}
    >
      <RelayAccessRequestFormFields mode="create" />
    </SimpleForm>
  );
};

const RelayAccessRequestCreate = (props: CreateProps) => (
  <Create {...props} redirect="show" transform={transformRelayAccessRequestCreate}>
    <RelayAccessRequestCreateForm />
  </Create>
);

export default RelayAccessRequestCreate;
